import React from 'react'

function Whyus({whysvg,h1}) {
  return (
    <div className='why-card'>
      <span>{whysvg}</span>
      <h1>{h1}</h1>
    </div>
  )
}

export default Whyus
